export const SKILLS = [
    {
      title: "Frontend",
      icons: "frontendIcon.png",
      skills: [
        { skill: "HTML", percentage: "80%" },
        { skill: "CSS", percentage: "80%" },
        { skill: "JavaScript", percentage: "70%" },
        { skill: "React", percentage: "70%" }
      ]
    },
    {
      title: "Backend",
      icons: "backendIcon.png",
      skills: [
        { skill: "Node.js", percentage: "60%" },
        { skill: "Express", percentage: "50%" },
        { skill: "MongoDB", percentage: "70%" }
      ]
    },
    {
      title: "Databases",
      icons: "databaseIcon.png",
      skills: [
        { skill: "MySQL", percentage: "80%" },
        { skill: "MongoDB", percentage: "70%" },
        
      ]
    },
    {
      title: "Testing",
      icons: "testingIcon.png",
      skills: [
        { skill: "Katalon Studio", percentage: "70%" }
      ]
    },
    {
      title: "UI/UX",
      icons: "uiuxIcon.png",
      skills: [
        { skill: "Figma", percentage: "70%" },
      ]
    },
  ]

export const WORK_EXPERIENCE = [
  {
    title: "Lab Demonstrator at FAST NUCES Islamabad ",
    date: "Sep 2023 - Present",
    responsibilities: [
      "assisting juniors in their tasks",
      "evaluate lab tasks",
      "required to be present in lab time of 3 hours"
    ],
  },
  {
    title: "FQSS- FAST Quran & Sunnah Society Operations Coordinator",
    date: "Oct 2022 - Present",
    responsibilities: [
      "Organize and manage the society's events and activities",
      "Assist my team with their queries",
    ],
  },
  {
    title: "Microsoft Learn Student Ambassador (MLSA) FAST NUCES Vice Head Operations",
    date: "Oct 2023 - Present",
    responsibilities: [
      "Organize and manage the society's events and activities",
      "Assist my team with their queries",
    ],
  },
  {
    title: "Internee at CodeSoft",
    date: "Oct 2023 - Nov 2023",
    responsibilities: [
      "Complete daily tasks of Java Programming concepts",
      "open successful completion, we get the certificate"
    ],
  },
  {
    title: "Internee at Interns Pakistan",
    date: "Jun 2023 - Jul 2023",
    responsibilities: [
      "Complete daily tasks of HTML, CSS, JavaScript concepts",
      "open successful completion, we get the certificate"
    ],
  },
  {
    title: "Web Development Course at DataCollide",
    date: "Jun 2023 - Jul 2023",
    responsibilities: [
      "Complete daily tasks of HTML, CSS, JavaScript concepts",
      "be present daily and perform daily tasks",
      "submit final project to get certificate upon completion"
    ],
  }
]
